import { useSelector } from 'react-redux';

export const useAuth = () => {
	const { user_email } = useSelector((state) => state.user);
	const { requestLogin } = useSelector((state) => state.institution);

	const isAuth = () => {
		return user_email.length > 0 ? true : false;
	};

	const hasHasLoggingSettingsActive = () => {
		return requestLogin;
	};

	const isUserLoggedInAndHasLoggingSettingsActive = () => {
		return hasHasLoggingSettingsActive() ? isAuth() : true;
	};

	return {
		isAuth,
		hasHasLoggingSettingsActive,
		isUserLoggedInAndHasLoggingSettingsActive,
	};
};
